export function Field({ label, children }) {
  return (
    <div class="field">
      <label>
        {label}
        {children}
      </label>
    </div>
  );
}
